import FooterView from "./view";

export interface FooterProps {
}

function Footer() {

    const props: FooterProps = {
    }

    return <FooterView {...props} />
}

export default Footer;
